import { FC, useState } from "react"
import { useFindContactFormsQuery } from "../../../../../redux/queries"
import { Integration } from "../../../../../types"
import { useIntegrationSettingsForm } from "../../../../hooks"
import Form from "../../../form"

interface Props {
  integration?: Integration
}

const ContactFormSelector: FC<Props> = ({ integration }) => {
  const { app_settings, saveSetting } = useIntegrationSettingsForm(integration)
  const { settings } = app_settings ?? {}

  const [selectedID, setSelectedFormID] = useState<string>(
    String(settings?.contactForm ?? "")
  )

  const { data: forms = [], isLoading } = useFindContactFormsQuery(
    integration?.brand_id as string
  )

  const setSelected = (contactFormID: string) => {
    if (contactFormID !== selectedID) {
      setSelectedFormID(contactFormID)
      saveSetting({ contactForm: contactFormID })
    }
  }

  return (
    <Form.Select
      label="Choose a form"
      showLabel={false}
      size="sm"
      isLoading={isLoading}
      data={forms}
      setSelected={setSelected}
      selected={selectedID || undefined}
    />
  )
}

export default ContactFormSelector
